import { ChevronDown } from '@griply/assets';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse } from 'shared/components/ui/collapse';
import { Icon } from 'shared/components/ui/icon';
import { useToggle } from 'shared/hooks/use-toggle';

import * as Styled from './faq-item.style';

export type FaqItemProps = {
  questionKey: string;
  answerKey: string;
};

export const FaqItem: React.FC<FaqItemProps> = ({ questionKey, answerKey }) => {
  const { t } = useTranslation();
  const [isOpen, toggleOpen] = useToggle(false);

  return (
    <Styled.FaqItem>
      <Styled.FaqQuestion type="button" onClick={toggleOpen}>
        <Typography variant="subtitle1" component="span">
          {t(questionKey)}
        </Typography>
        <Styled.FaqChevron $isOpen={isOpen}>
          <Icon icon={ChevronDown} size={20} strokeWidth={2} />
        </Styled.FaqChevron>
      </Styled.FaqQuestion>

      <Collapse isOpen={isOpen}>
        <Styled.FaqAnswer>{t(answerKey)}</Styled.FaqAnswer>
      </Collapse>
    </Styled.FaqItem>
  );
};
